export const ROUTE_PATH = '/mall-reception-users';
